import React, { useState } from 'react';
import { SectionHeader, Callout } from '../components/UI';
import { Switch } from '../components/ui/switch';

const DEFAULT_ALERTS = [
  { key: 'pace', label: 'Revenue below 90% of mid-month pace', tone: 'Daily at noon', on: true },
  { key: 'ad_cap', label: 'Ad spend above 30% of revenue', tone: 'When exceeded', on: true },
  { key: 'cash_floor', label: 'Projected cash drops below $200K', tone: 'Immediate', on: true },
  { key: 'roas', label: 'ROAS below 2.5x for 7 straight days', tone: 'Rolling check', on: true },
  { key: 'gusto_comp', label: 'Gusto comp change not in forecast', tone: 'On detection', on: false },
  { key: 'close_reminder', label: '"Close the month" reminder on the 5th', tone: 'Monthly', on: true },
];

export default function Alerts() {
  const [alerts, setAlerts] = useState(DEFAULT_ALERTS);
  const toggle = (k) => setAlerts((prev) => prev.map((a) => (a.key === k ? { ...a, on: !a.on } : a)));

  return (
    <div className="space-y-10">
      <SectionHeader
        eyebrow="Alerts"
        title="Quiet when things are fine. Loud when they aren't."
        description="Configure the alerts that ping the designated Slack channel (and email) when thresholds cross."
      />

      <Callout title="Phase 2">
        Alert delivery to Slack & email is wired up in the next phase. You can adjust the thresholds here now —
        they'll take effect the moment the integrations go live.
      </Callout>

      <div className="bg-white border-t-4 border-indie-navy divide-y divide-indie-navy/10">
        {alerts.map((a) => (
          <div key={a.key} className="flex items-center justify-between px-6 py-4 gap-4" data-testid={`alert-${a.key}`}>
            <div>
              <div className="font-medium text-indie-navy">{a.label}</div>
              <div className="text-xs uppercase tracking-wider text-indie-ink/50 mt-0.5">{a.tone}</div>
            </div>
            <Switch checked={a.on} onCheckedChange={() => toggle(a.key)} />
          </div>
        ))}
      </div>
    </div>
  );
}
